<template>
  <div class="relative overflow-hidden " :class="'grad-theme-' + theme">
    <div class="absolute  inset-0 z-1" />
    <div v-if="image?.src" class="absolute inset-0 z-2 opacity-20">
      <DisplayImage v-bind="image" class="object-cover w-full h-full" />
    </div>
    <img src="/icon.svg" class="absolute -bottom-24 -right-64 z-3 w-1/3 h-auto">
    <div class="relative flex flex-col px-6 md:px-12 lg:px-16 max-w-7xl z-3"
      :class="[image?.src ? 'py-64 lg:py-96' : 'pb-12 pt-64']">
      <p v-if="leadin" class="text-2xl header md:text-3xl lg:text-4xl text-white/80 gsap-hero-subtitle text-balance">
        {{ leadin }}
      </p>
      <h1 class="text-4xl header md:text-6xl lg:text-7xl xl:text-8xl 2xl:text-9xl text-balance gsap-hero-title ">
        {{ title }}
      </h1>
      <slot />
      <Markdown v-if="body" :md="body" class="text-2xl max-w-4xl gsap-hero-text " />
      <div class="flex flex-wrap gap-3">
        <ButtonGeneral v-for="(button, index) in buttons" :key="index" v-bind="button"
          class="self-start mt-6 md:mt-6 lg:mt-8" theme="light" />
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { onMounted } from 'vue'
import { gsap } from 'gsap'
import { SplitText } from 'gsap/SplitText'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import type { GeneralSection, Button, Image, Theme } from '~/types'

gsap.registerPlugin(SplitText, ScrollTrigger)

interface Props extends /* @vue-ignore */ GeneralSection {
  title?: string
  leadin?: string
  body?: string
  buttons?: Button[]
  image?: Image
  index: number
  theme: Theme
}
const { theme = '' } = defineProps<Props>()
onMounted(async () => {
  // document.fonts.ready.then(() => {
  startAnimation()
  // })
})

function startAnimation() {
  gsap.set('.gsap-hero-title', {
    autoAlpha: 1,
  })
  gsap.set('.gsap-hero-subtitle', {
    autoAlpha: 1,
  })
  gsap.set('.gsap-hero-text', {
    autoAlpha: 1,
  })
  SplitText.create('.gsap-hero-title', {
    type: 'words, chars',
    charsClass: 'char-mask',
    wordsClass: 'word-mask',
    mask: 'chars',
    autoSplit: true,
    onSplit: (self: SplitText) => {
      self.chars.forEach((char) => {
        // debugger

        char.style.paddingBottom = '16px'
      })

      return gsap.from(self.chars, {
        autoAlpha: 0,
        // yPercent: 'random([-40,100])',
        y: 150,
        ease: 'power3.out',
        duration: 1.2,
        // duration: 1,
        // ease: 'power2.out',
        // stagger: {
        //   amount: 0.5,
        //   from: 'edges',
        // },
      })
    },
  })
  SplitText.create('.gsap-hero-subtitle', {
    type: 'words, chars',
    charsClass: 'char-mask',
    wordsClass: 'word-mask',
    mask: 'chars',
    autoSplit: true,
    onSplit: (self: SplitText) => {
      self.chars.forEach((char) => {
        // debugger

        char.style.paddingBottom = '16px'
      })

      return gsap.from(self.chars, {
        autoAlpha: 0,
        // yPercent: 'random([-40,100])',
        y: 300,
        ease: 'power3.out',
        duration: 0.8,
        // duration: 1,
        // ease: 'power2.out',
        // stagger: {
        //   amount: 0.5,
        //   from: 'edges',
        // },
      })
    },
  })
  SplitText.create('.gsap-hero-text', {
    type: 'words, chars',
    charsClass: 'char-mask',
    mask: 'chars',
    autoSplit: true,
    onSplit: (self: SplitText) => {
      return gsap.from(self.chars, {
        autoAlpha: 0,
        y: 400,
        // duration: 5,
        // ease: 'power2.out',
        stagger: {
          amount: 0.5,
          from: 'start',
        },
        delay: 0.1,

      })
    },
  })
}
</script>

<style lang="css" scoped>
.char-mask,
.gsap-hero-title,
.gsap-hero-text {
  /* visibility: hidden; */
  overflow: visible !important;
}

.char-mask {
  padding-bottom: 100px !important;
}
</style>
